export default __webpack_public_path__ + "static/media/TransportationPlanes_05.1ee76809.png";